import {CommonModule, NgOptimizedImage} from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SimpleLayoutComponent } from './simple-layout/simple-layout.component';
import { AuthSharedDialogsModule } from '../pages/authentication/shared-dialogs/auth-shared-dialogs.module';

const components = [
  HeaderComponent,
  SidebarComponent,
  SimpleLayoutComponent,
  PageHeaderComponent,
  BreadcrumbsComponent,
  FooterComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, SharedModule, NgOptimizedImage, AuthSharedDialogsModule],
})
export class LayoutModule {}
